import type { SafetyCheckResult } from './types';

const DENY_LIST_PATTERNS: RegExp[] = [
  // Private/secret keys and seed phrases
  /\b(private[\s_-]?key|secret[\s_-]?key|api[\s_-]?secret|password|seed[\s_-]?phrase|mnemonic)\b/i,
  // Credit card numbers (4 groups of 4 digits)
  /\b(\d{4}[\s-]?\d{4}[\s-]?\d{4}[\s-]?\d{4})\b/,
  // Email addresses
  /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b/,
  // Common secret patterns (bearer tokens, JWT-like)
  /\b(Bearer\s+[A-Za-z0-9._-]{20,})\b/,
  // Hex strings that look like private keys (64+ hex chars)
  /\b(0x)?[0-9a-f]{64,}\b/i,
];

const REDACT_REPLACEMENT = '[REDACTED]';

export function checkSafety(input: string): SafetyCheckResult {
  let redactedInput = input;
  let anyMatch = false;

  for (const pattern of DENY_LIST_PATTERNS) {
    if (pattern.test(redactedInput)) {
      redactedInput = redactedInput.replace(new RegExp(pattern.source, pattern.flags + 'g'), REDACT_REPLACEMENT);
      anyMatch = true;
    }
  }

  if (anyMatch) {
    return {
      safe: false,
      redactedInput,
      reason: 'Input contained sensitive information that was redacted.',
    };
  }

  return { safe: true };
}
